import React from 'react';

import { isFunction as _isFunction } from 'lodash';

import { VFScreen } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import AddOnDetailsContainer from '../../../../BusinessOverview/AddOns/Containers/AddOnDetails';
import { PROFILE_ADD_ON_DETAILS_QUICK_ACTION_MENU_CONFIG } from '../../../../BusinessOverview/AddOns/Containers/AddOnDetails/AddOnDetails.Enum';
import AddOnDetailsPropTypes from '../../../../Common/PropTypes/AddOnDetailsPropTypes';

import styles from './AddOnDetails.Styles';
import {
  getQAModeOnPrimaryButtonPress,
  getPrimaryButtonTitle,
  getSecondaryButtonTitle,
} from './AddOnDetails.Utils';

function AddOnDetails({ vfScreenProps, onPrimaryButtonPress, onSecondaryButtonPress, ...props }) {
  const theme = useTheme();

  const _onPrimaryButtonPress = (mode, onActionPress) => {
    const _QAmode = getQAModeOnPrimaryButtonPress(mode);
    onActionPress(_QAmode);
    _isFunction(onPrimaryButtonPress) && onPrimaryButtonPress();
  };

  const _onSecondaryButtonPress = mode => {
    _isFunction(onSecondaryButtonPress) && onSecondaryButtonPress(mode);
  };

  return (
    <VFScreen withHeader={false} containerStyle={styles.container(theme)} {...vfScreenProps}>
      <AddOnDetailsContainer
        withUsers={false}
        getPrimaryButtonTitle={getPrimaryButtonTitle}
        getSecondaryButtonTitle={getSecondaryButtonTitle}
        onPrimaryButtonPress={_onPrimaryButtonPress}
        onSecondaryButtonPress={_onSecondaryButtonPress}
        QAConfig={PROFILE_ADD_ON_DETAILS_QUICK_ACTION_MENU_CONFIG}
        theme={theme}
        {...props}
      />
    </VFScreen>
  );
}

AddOnDetails.propTypes = AddOnDetailsPropTypes;
export default AddOnDetails;
